import React, { useEffect, useState } from 'react';
import SHRMMessage from '../../common/components/SHRMMessage';
import { useAppDispatch, useAppSelector } from '../../common/hooks';
import { IChapterBilling } from '../../models/Chapter/IChapterBilling';
import { IProfileForm } from '../../models/Profile/IProfileForm';
import { setProfile } from '../../redux/profileSlice';
import { RootState } from '../../redux/store';

import {
  getChaptersForState,
  getProfile,
  handleErrorResponse,
  updateProfile,
} from '../../services';
import ProfileEditMode from './components/ProfileEditMode';
import ProfileReadMode from './components/ProfileReadMode';
import styles from './ProfilePage.module.css';
import { format, parse } from 'date-fns';
import LoadingSpinner from '../../common/components/LoadingSpinner';
import clsx from 'clsx';

const ProfilePage = () => {
  // const [profileContainer, setProfileContainer] = useState<IProfileContainer>(
  //   {} as IProfileContainer
  // );
  const [chaptersBilling, setChaptersBilling] = useState<IChapterBilling[]>(
    {} as IChapterBilling[]
  );
  const [showEditMode, setShowEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [popupMesage, setPopupMessage] = useState('');
  const [popupMessageColor, setPopupMessageColor] = useState('');
  const [showPopupMessage, setShowPopupMessage] = useState(false);
  const [chapterState, setChapterState] = useState('');

  const dispatch = useAppDispatch();

  const profileContainer = useAppSelector(
    (state: RootState) => state.profileReducer.profileContainer
  );

  const toggleReadEditMode = () => {
    setShowEditMode(!showEditMode);
  };

  const getDateForNetsuite = (_date: string) => {
    var formattedDate = _date ? format(parse(_date, 'yyyy-MM-dd', new Date()), 'M/d/y') : '';
    return formattedDate;
  };

  const getDay = (_date: string) => {
    var formattedDate = _date ? format(parse(_date, 'yyyy-MM-dd', new Date()), 'd') : '';
    return formattedDate;
  };

  const getMonth = (_date: string) => {
    var formattedDate = _date ? format(parse(_date, 'yyyy-MM-dd', new Date()), 'M') : '';
    return formattedDate;
  };

  const getYear = (_date: string) => {
    var formattedDate = _date ? format(parse(_date, 'yyyy-MM-dd', new Date()), 'y') : '';
    return formattedDate;
  };

  const saveProfile = (profileForm: IProfileForm) => {
    const profileFromRedux = profileContainer?.profileModel;
    const profile = { ...profileFromRedux };
    setIsLoading(true);
    if (profile && profileForm) {
      profile.prefix = profileForm.prefix;
      profile.firstName = profileForm.firstName;
      profile.middleName = profileForm.middleName;
      profile.lastName = profileForm.lastName;
      profile.suffix = profileForm.suffix;
      profile.nickName = profileForm.nickName;
      profile.birthDate = getDateForNetsuite(profileForm.dateOfBirth);
      profile.birthDay = getDay(profileForm.dateOfBirth);
      profile.birthMonth = getMonth(profileForm.dateOfBirth);
      profile.birthYear = getYear(profileForm.dateOfBirth);
      // profile.gender = profileForm.gender;
      profile.gcrGenderSex = profileForm.gcrGenderSex;
      profile.gcrEthnicityRace = profileForm.gcrEthnicityRace;
      // profile.ethnicity = profileForm.ethnicity;
      profile.primaryLanguage = profileForm.primaryLanguage;
      profile.educationLevel = profileForm.educationLevel;
      profile.gcrStudent = profileForm.gcrStudent;
      profile.altEmail = profileForm.altEmail;
      profile.gcrHrInterest = profileForm.gcrHrInterest;
      profile.gcrContentFormatPreference = profileForm.gcrContentFormatPreference;
      profile.gcrContentChannelPreference = profileForm.gcrContentChannelPreference;
      profile.gcrJobFunctionOthers = profileForm.gcrJobFunctionOthers;
      profile.companyDnbNumber = profileForm.companyDnbNumber;
      profile.companyName = profileForm.companyName;
      profile.companySelected = profileForm.companySelected;
      // profile.hrDepartmentSize = profileForm.hrDepartmentSize;
      profile.gcrIndustry = profileForm.gcrIndustry;
      profile.gcrCompanySize = profileForm.gcrCompanySize;
      profile.jobTitle = profileForm.jobTitle;
      profile.gcrJobFunctionPrimary = profileForm.gcrJobFunctionPrimary;
      profile.gcrJobFunctionSecondary = profileForm.gcrJobFunctionSecondary;
      profile.gcrJobLevel = profileForm.gcrJobLevel;
      // archived
      // profile.specialtyCode = profileForm.specialtyCode;
      // profile.specialtyOther = profileForm.specialtyOther;

      // profile.industryType = profileForm.industryType;

      profile.yearStartedHR = profileForm.yearStartedHR;
      profile.exemptionStatus = profileForm.exemptionStatus;
      profile.supervisorsTitle = profileForm.supervisorsTitle;
      profile.chapterState = profileForm.chapterState;
      profile.isChapterDualBilling = profileForm.isChapterDualBilling;
      profile.chapterId = profileForm.chapterId;
      profile.chapterName = profileForm.chapterId;
      profile.academicMajor = profileForm.academicMajor;
      profile.university = profileForm.university;
      profile.universityDnbNumber = profileForm.universityDnbNumber;
      profile.universitySelected = profileForm.universitySelected;
      profile.graduationDate = getDateForNetsuite(profileForm.graduationDate);
      profile.enrollmentStatus = profileForm.enrollmentStatus;
      profile.numberCredits = profileForm.numberCredits;
      profile.creditTerm = profileForm.creditTerm;
      return updateProfile(profile.masterCustomerId, profile)
        .then((_response: any) => {
          return getProfile(profile.masterCustomerId);
        })
        .then((response: any) => {
          dispatch(setProfile(response.data));
          setShowEditMode(false);
          window.scrollTo(0, 0);
          setPopupMessage('✔︎ Profile updated.');
          setPopupMessageColor('var(--shrmGreen)');
          setShowPopupMessage(true);
        })
        .catch((_error: any) => {
          const message = handleErrorResponse(_error);
          setPopupMessage(message);
          setPopupMessageColor('var(--shrmRed)');
          setShowPopupMessage(true);
        })
        .finally(() => {
          setIsLoading(false);
          setTimeout(() => {
            setShowPopupMessage(false);
          }, 3000);
        });
    } else {
      alert('No profile data!');
    }
  };

  const handleChapterSelect = (state: string) => {
    const chapterStateValue =
      profileContainer?.profileModel?.chapterState !== state
        ? state
        : profileContainer?.profileModel?.chapterState;
    setChapterState(chapterStateValue);
    getChaptersForState(profileContainer?.profileModel?.masterCustomerId, state, 'PRO')
      .then((response: any) => {
        setChaptersBilling(response.data);
      })
      .catch((_error: any) => {
        handleErrorResponse(_error);
      });
    return [];
  };

  useEffect(() => {
    setIsLoading(true);
    getProfile(profileContainer?.profileModel?.masterCustomerId)
      .then((response: any) => {
        dispatch(setProfile(response.data));
        if (profileContainer?.profileModel?.chapterId) {
          return getChaptersForState(
            profileContainer?.profileModel?.masterCustomerId,
            profileContainer.profileModel.chapterState,
            'PRO'
          );
        }
      })
      .then((response: any) => {
        if (response) {
          setChaptersBilling(response.data);
        }
      })
      .catch((_error: any) => {
        handleErrorResponse(_error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [showEditMode]);

  return (
    <div>
      {isLoading ? (
        <div className={clsx(styles.container, styles.center)}>
          <LoadingSpinner />
        </div>
      ) : (
        <React.Fragment>
          <div className={styles.container}>
            <SHRMMessage
              color={popupMessageColor}
              text={popupMesage}
              showMessage={showPopupMessage}
            />
            {showEditMode ? (
              <ProfileEditMode
                profileContainer={profileContainer}
                chaptersBilling={chaptersBilling}
                handleChapterSelect={handleChapterSelect}
                chapterState={chapterState}
                toggleEditMode={toggleReadEditMode}
                saveProfile={saveProfile}
              />
            ) : (
              <ProfileReadMode
                profileContainer={profileContainer}
                toggleEditMode={toggleReadEditMode}
              />
            )}
          </div>
        </React.Fragment>
      )}
    </div>
  );
};
export default ProfilePage;
